import { render, staticRenderFns } from "./NavItemLink.vue?vue&type=template&id=7f2932f2"
import script from "./NavItemLink.vue?vue&type=script&lang=ts"
export * from "./NavItemLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports